import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {UseLoader} from "../../../hooks/useLoader";
import {confirmDialog} from "primereact/confirmdialog";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {Calendar} from "primereact/calendar";
import {error} from "../../../shared/utils/utils";
import {editarContrato} from "../../../api/contrato.service";
import NumberFormat from "react-number-format";


export const ModalEditarContrato = ({show, hide, fields}) => {
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const initParams = {
        codigo: '',
        cliente_id: "",
        contratomarco_id: "",
        fecha_fin: new Date(),
        fecha_inicial: new Date(),
        nombre: "",
        tipo_id: "",
        valor_bruto: "",
        observacion: "",
        contrato_id: ""
    };

    const [field, setField] = useState(initParams);

   useEffect(() => {
        setField({
            codigo: fields.codigo,
            cliente_id: fields.cliente_id,
            contratomarco_id: fields.contratomarco_id,
            fecha_fin: fields.fecha_fin,
            fecha_inicial: fields.fecha_ini,
            nombre: fields.nombre,
            tipo_id: fields.tipo_id,
            valor_bruto: fields.valor_bruto,
            contrato_id: fields.contrato_id,
            observacion: ''
        })

        return () => {
            setField(initParams)
        };
    }, [fields]);



    const onSubmit = async (e) => {
        try {
            e.preventDefault();
            console.log(field.codigo)
            if (
                field.fecha_fin === ''
                || field.fecha_fin === ''
                || field.valor_bruto === ''
                || field.observacion === ''
                || field.codigo === ''
            ) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () =>  {
                    handleLoad(true)
                    const response = await editarContrato(field);
                    const data = await response.data;
                    handleLoad(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide()

                }
            });

        } catch (e) {
            handleLoad(false)
            console.log(e)
        }

    }
    return (
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Editar contrato" visible={show} style={{width: '90vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={onSubmit} autoComplete="false">
                            <h6 className="title-modal">
                                Información Contrato {field.codigo}
                            </h6>

                            <div className="row">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="cliente"
                                    >
                                        Cliente
                                    </label>
                                    <input type="text" id="cliente" readOnly  defaultValue={field.nombre} className="form-input-small" />
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="tipo"
                                    >
                                        Tipo
                                    </label>
                                    <select disabled={true} className="form-input-small" name="tipo" id="tipo" defaultValue={field.tipo_id}>
                                        <option value="I">Inicio</option>
                                        <option value="O">Adición / otro</option>
                                    </select>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="codigo"
                                    >
                                        UCC *
                                    </label>
                                    <input type="text" id="codigo"  value={field.codigo}   onChange={(e) => setField({...field, codigo: e.target.value})} className="form-input-small" />
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="fechacrea"
                                    >
                                        Fecha inicial *
                                    </label>
                                    <Calendar id="fechacrea"
                                              value={new Date(field.fecha_inicial)}
                                              locale="es"
                                              dateFormat="yy-mm-dd"
                                              style={{width: "100%"}}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange='2010:2030'
                                              onChange={(e) => setField({...field, fecha_inicial: e.value})} showIcon/>
                                    {error(field.fecha_inicial, 'required')}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="fechaFinal"
                                    >
                                        Fecha Final *
                                    </label>
                                    <Calendar id="fechaFinal"
                                              value={new Date(field.fecha_fin)}
                                              locale="es"
                                              style={{width: "100%"}}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange='2010:2030'
                                              dateFormat="yy-mm-dd"
                                              onChange={(e) => setField({...field, fecha_fin: e.value})} showIcon/>
                                    {error(field.fecha_fin, 'required')}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="valor"
                                    >
                                        Valor *
                                    </label>
                                    <NumberFormat
                                        id="valor"
                                        thousandsGroupStyle="thousand"
                                        value={field.valor_bruto}
                                        prefix="$"
                                        displayType="input"
                                        type="text"
                                        decimalSeparator="."
                                        className="form-input"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        onValueChange={(e) => setField({...field, valor_bruto: e.value})}
                                    />

                                    {error(field.valor_bruto, 'required')}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="observacion"
                                    >
                                        Observación *
                                    </label>
                                    <textarea
                                        id="observacion"
                                        rows="2"
                                        className="form-input"
                                        value={field.observacion}
                                        onChange={(e) => setField({...field, observacion: e.target.value})}
                                    >
                                </textarea>

                                    {error(field.observacion, 'required')}
                                    {error(field.observacion, 'maxLength', 200)}
                                </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>
        </>
    );
};

ModalEditarContrato.propTypes = {
    show: PropTypes.bool,
    hide: PropTypes.func,
    fields: PropTypes.object
};

ModalEditarContrato.defaultProps = {
    show: false,
};
